'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _input = require('@alicd/next/lib/input');

var _input2 = _interopRequireDefault(_input);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cruiFormItem = require('@alicd/crui-form-item');

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputField = function (_React$Component) {
  (0, _inherits3.default)(InputField, _React$Component);

  function InputField() {
    (0, _classCallCheck3.default)(this, InputField);
    return (0, _possibleConstructorReturn3.default)(this, (InputField.__proto__ || (0, _getPrototypeOf2.default)(InputField)).apply(this, arguments));
  }

  (0, _createClass3.default)(InputField, [{
    key: 'focus',
    value: function focus() {
      if (this.input) {
        this.input.refs.input.focus();
      }
    }
  }, {
    key: 'getRef',
    value: function getRef(e) {
      if (e) {
        this.input = e;

        // if(this.props.focused){
        //   this.input.refs.input.focus();
        // }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      /* eslint-disable */
      var _props = this.props,
          bind = _props.bind,
          style = _props.style,
          inputStyle = _props.inputStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['bind', 'style', 'inputStyle']);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          className = other.className,
          otherInput = (0, _objectWithoutProperties3.default)(other, ['labelCol', 'wrapperCol', 'mapping', 'className']);
      /* eslint-enable */

      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({}, other, { style: style }),
        _react2.default.createElement(_input2.default, (0, _extends3.default)({ ref: this.getRef.bind(this) }, otherInput, { style: inputStyle }))
      );
    }
  }]);
  return InputField;
}(_react2.default.Component);

InputField.propTypes = {
  focused: _propTypes2.default.bool
};
InputField.defaultProps = {
  focused: false
};
exports.default = InputField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-input-field@0.0.13@@alicd/crui-input-field/lib/index.js
// module id = 639
// module chunks = 0